<template>
  <v-card class=" tools-view-card">
    <ToolbarHeader :name="'Data Table'"/>
    <v-container>
      <section class="ma-5"> 123
        <qsc-data-table :columns="dataTable.columns"
                        :rows="dataTable.rows"
                        :suggest="true"
                        :suggest-url="dataTable.suggestUrl"
                        :auth="false"
                        :total-rows="ITEMS_DOCUMENTS_TOTAL_RESULT"
                        :page-count="ITEMS_DOCUMENTS_PAGE_COUNT"
                        :per-page="searchQuery.rows"
                        :filters="true"
                        :filters-list="searchQuery.searchFilters"
                        v-on:changePagination="handleChangePagination($event)"
                        v-on:changeVisibleResults="handleChangeVisibleResults($event)"
                        v-on:changeSuggest="handleChangeSuggest($event)"
                        v-on:changeSort="handleChangeSort($event)"
                        v-on:addFilter="handleAddFilter($event)"
                        v-on:addNotFilter="handleAddNotFilter($event)"
                        v-on:removeFilter="handleRemoveFilter($event)"/>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {mapGetters} from "vuex";
export default {
  name: "DataTable",
  components: {ToolbarHeader},
  data: () => ({
    dataTable: {
      suggestUrl: 'https://qsc-dev.quasiris.de/api/v1/search/suggest/hornbach-de/search',
      columns: [],
      rows: [],
    },
    searchQuery: {
      page: 1,
      q: "*",
      rows: 20,
      searchFilters: [],
      sliders: [],
    },
  }),
  computed: {
    ...mapGetters([
      'ITEMS_DOCUMENTS',
      'ITEMS_DOCUMENTS_TOTAL_RESULT',
      'ITEMS_DOCUMENTS_PAGE_COUNT',
      'ITEMS_DOCUMENTS_PAGING',
    ]),
  },
  mounted() {
    this.postItemsDocuments(true);
  },
  methods: {
    postItemsDocuments(mounted) {
      this.$store.dispatch('POST_ITEMS_DOCUMENTS_WITH_SEARCH_QUERY', {
        searchQuery: this.searchQuery
      })
          .then(() => {
            this.setDataTable(mounted);
          })
    },
    setDataTable(mounted) {
      if (mounted) {
        this.dataTable.columns = ['title', 'price', 'brand']
      }

      this.dataTable.rows = [];
      for (let i = 0; i < this.ITEMS_DOCUMENTS.length; i++) {
        this.dataTable.rows[i] = this.ITEMS_DOCUMENTS[i].document;
        this.dataTable.rows[i]['id'] = this.ITEMS_DOCUMENTS[i].id;
      }

      this.tableLoading = false;
    },
    handleChangePagination(page) {
      this.searchQuery.page = page;
      this.postItemsDocuments(false);
    },
    handleChangeVisibleResults(results) {
      this.searchQuery.rows = results;
      this.postItemsDocuments(false);
    },
    handleChangeSuggest(suggest) {
      this.searchQuery.q = suggest;
      this.searchQuery.page = 1;
      this.postItemsDocuments(false);
    },
    handleChangeSort({field, direction}) {
      this.searchQuery.sort.field = field;
      this.searchQuery.sort.direction = direction;

      this.postItemsDocuments(false);
    },

    handleAddFilter({id, values}) {
      this.searchQuery.searchFilters.push({
        id: id,
        values: values
      });

      this.postItemsDocuments(false);
    },
    handleAddNotFilter({id, values}) {
      this.searchQuery.searchFilters.push({
        id: id,
        values: values,
        filterOperator: "NOT"
      });

      this.postItemsDocuments(false);
    },
    handleRemoveFilter(index) {
      this.searchQuery.searchFilters.splice(index, 1);
      this.postItemsDocuments(false);
    },
  }
}
</script>

<style scoped>

</style>
